<template>
  <div class="page">
    <div @keydown="onKeyDown"></div>
    <div class="cube">
      <div class="row">
        <div class="layer"></div>
        <div class="layer">
          <div class="line" v-for="(line, i) in cube[1]" :key="i">
            <div class="item" v-for="(item, j) in line" :key="j" :style="{ backgroundColor: color[item] }"></div>
          </div>
        </div>
        <div class="layer"></div>
        <div class="layer"></div>
      </div>
      <div class="row">
        <div class="layer">
          <div class="line" v-for="(line, i) in cube[2]" :key="i">
            <div class="item" v-for="(item, j) in line" :key="j" :style="{ backgroundColor: color[item] }"></div>
          </div>
        </div>
        <div class="layer">
          <div class="line" v-for="(line, i) in cube[5]" :key="i">
            <div class="item" v-for="(item, j) in line" :key="j" :style="{ backgroundColor: color[item] }"></div>
          </div>
        </div>
        <div class="layer">
          <div class="line" v-for="(line, i) in cube[3]" :key="i">
            <div class="item" v-for="(item, j) in line" :key="j" :style="{ backgroundColor: color[item] }"></div>
          </div>
        </div>
        <div class="layer">
          <div class="line" v-for="(line, i) in cube[4]" :key="i">
            <div class="item" v-for="(item, j) in line" :key="j" :style="{ backgroundColor: color[item] }"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="layer"></div>
        <div class="layer">
          <div class="line" v-for="(line, i) in cube[0]" :key="i">
            <div class="item" v-for="(item, j) in line" :key="j" :style="{ backgroundColor: color[item] }"></div>
          </div>
        </div>
        <div class="layer"></div>
        <div class="layer"></div>
      </div>
    </div>
    <div class="rubik_out" :style="{ transform: `rotateX(${view.x}deg) rotateY(${view.y}deg) rotateZ(${view.z}deg)` }">
      <div class="rubik" :style="{ transform: rotate.str }">
          <div class="face" :class="position[index]" v-for="(face, index) in cube" :key="index">
            <div class="line" v-for="(line, i) in face" :key="i">
              <div class="item" v-for="(item, j) in line" :key="j" :style="{ backgroundColor: color[item], borderRadius: radius[i][j] }"
                :data-index="index" :data-i="i" :data-j="j"
                >
                <img src="https://ss.sxmfxh.com/static/img/gan.f7c6ea32.jpg" v-if="item == 1 && i == 1 && j == 1" :style="{ transform: `rotate(${rotate.center}deg)` }">
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="desc" :class="{ 'hidden': hidden }">
      <div class="icon" @click="onChange">×</div>
      <div class="table">
        <div class="line">
          <div class="grid">操作</div>
          <div class="grid">B</div>
          <div class="grid">D</div>
          <div class="grid">L</div>
          <div class="grid">R</div>
          <div class="grid">U</div>
          <div class="grid">F</div>
          <div class="grid">x</div>
          <div class="grid">y</div>
          <div class="grid">z</div>
          <div class="grid">上仰</div>
          <div class="grid">下俯</div>
        </div>
        <div class="line">
          <div class="grid">按键</div>
          <div class="grid bold">Q</div>
          <div class="grid bold">W</div>
          <div class="grid bold">E</div>
          <div class="grid bold">I</div>
          <div class="grid bold">O</div>
          <div class="grid bold">P</div>
          <div class="grid bold">X</div>
          <div class="grid bold">C</div>
          <div class="grid bold">Z</div>
          <div class="grid bold">↑</div>
          <div class="grid bold">↓</div>

        </div>
        <div class="line">
          <div class="grid">操作</div>
          <div class="grid">B'</div>
          <div class="grid">D'</div>
          <div class="grid">L'</div>
          <div class="grid">R'</div>
          <div class="grid">U'</div>
          <div class="grid">F'</div>
          <div class="grid">x'</div>
          <div class="grid">y'</div>
          <div class="grid">z'</div>
          <div class="grid">左视</div>
          <div class="grid">右视</div>
        </div>
        <div class="line">
          <div class="grid">按键</div>
          <div class="grid bold">A</div>
          <div class="grid bold">S</div>
          <div class="grid bold">D</div>
          <div class="grid bold">J</div>
          <div class="grid bold">K</div>
          <div class="grid bold">L</div>
          <div class="grid bold">M</div>
          <div class="grid bold">,</div>
          <div class="grid bold">N</div>
          <div class="grid bold">←</div>
          <div class="grid bold">→</div>
        </div>
      </div>
    </div>
  </div>
  <a href="https://beian.miit.gov.cn" target="_blank" class="icp">
    CopyRight @2024 One魔方 蜀ICP备2023040766号
  </a>
</template>

<script>
export default {
  data() {
    return {
      view: {
        x: -18,
        y: 60,
        z: 0
      },
      rotate: {
        center: 0,
        str: ''
      },
      direction: [
        [ 'Z', 90 ],
        [ 'Y', -90 ],
        [ 'X', -90 ]
      ],
      color: [ '#808080', '#ffffff', '#FFFF00', '#FF0000', '#FFAA00', '#4E91FE', '#00DD00' ],
      position: [ 'bottom', 'top', 'left', 'right', 'back', 'front' ],
      radius: [
        [ '0 6px 6px 6px', '6px 6px 24px 24px', '6px 0 6px 6px' ],
        [ '6px 24px 24px 6px', '36px', '24px 6px 6px 24px' ],
        [ '6px 6px 6px 0', '24px 24px 6px 6px', '6px 6px 0 6px' ]
      ],
      axis: [ 0, 1, 2, 3, 4, 5 ],
      cube: [
        [ [ 1, 1, 1 ], [ 1, 1, 1 ], [ 1, 1, 1 ] ],
        [ [ 2, 2, 2 ], [ 2, 2, 2 ], [ 2, 2, 2 ] ],
        [ [ 3, 3, 3 ], [ 3, 3, 3 ], [ 3, 3, 3 ] ],
        [ [ 4, 4, 4 ], [ 4, 4, 4 ], [ 4, 4, 4 ] ],
        [ [ 5, 5, 5 ], [ 5, 5, 5 ], [ 5, 5, 5 ] ],
        [ [ 6, 6, 6 ], [ 6, 6, 6 ], [ 6, 6, 6 ] ],
      ],
      hidden: false
    }
  },

  mounted() {
    window.addEventListener('keydown', this.onKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  },

  methods: {
    onKeyDown(e) {
      if('qweiopasdjkl'.includes(e.key)) {
        const event = {
          q: { axis: 3, type: 1 },
          w: { axis: 0, type: 1 },
          e: { axis: 4, type: 1 },
          i: { axis: 5, type: 1 },
          o: { axis: 1, type: 1 },
          p: { axis: 2, type: 1 },
          a: { axis: 3, type: 0 },
          s: { axis: 0, type: 0 },
          d: { axis: 4, type: 0 },
          j: { axis: 5, type: 0 },
          k: { axis: 1, type: 0 },
          l: { axis: 2, type: 0 },
        }[e.key];
        if(!event) return;
        this.turnLayer(this.axis[event.axis], event.type);
      } else if('zxcnm,'.includes(e.key)) {
        const axis = JSON.parse(JSON.stringify(this.axis));
        const direction = JSON.parse(JSON.stringify(this.direction));
        var str = '';
        if(e.key == 'x') { // x -- R
          this.axis = [ axis[3], axis[2], axis[0], axis[1], axis[4], axis[5] ];
          str = `rotate${direction[0][0]}(${direction[0][1]}deg) `;
          this.direction = [ direction[0], direction[2], [ direction[1][0], direction[1][1] * -1 ] ];
        } else if(e.key == 'c') { // y -- U
          this.axis = [ axis[0], axis[1], axis[5], axis[4], axis[2], axis[3] ];
          str = `rotate${direction[1][0]}(${direction[1][1]}deg) `;
          this.direction = [ [ direction[2][0], direction[2][1] * -1 ], direction[1], direction[0] ];
        } else if(e.key == 'z') { // z -- F
          this.axis = [ axis[5], axis[4], axis[2], axis[3], axis[0], axis[1] ];
          str = `rotate${direction[2][0]}(${direction[2][1]}deg) `;
          this.direction = [ direction[1], [ direction[0][0], direction[0][1] * -1 ], direction[2] ];
        } else if(e.key == 'm') { // x' -- R'
          this.axis = [ axis[2], axis[3], axis[1], axis[0], axis[4], axis[5] ];
          str = `rotate${direction[0][0]}(${direction[0][1] * -1}deg) `;
          this.direction = [ direction[0], [ direction[2][0], direction[2][1] * -1 ], direction[1] ];
        } else if(e.key == ',') { // y' -- U'
          this.axis = [ axis[0], axis[1], axis[4], axis[5], axis[3], axis[2] ];
          str = `rotate${direction[1][0]}(${direction[1][1] * -1}deg) `;
          this.direction = [ direction[2], direction[1], [ direction[0][0], direction[0][1] * -1 ] ];
        } else if(e.key == 'n') { // z' -- F'
          this.axis = [ axis[4], axis[5], axis[2], axis[3], axis[1], axis[0] ];
          str = `rotate${direction[2][0]}(${direction[2][1] * -1}deg) `;
          this.direction = [ [ direction[1][0], direction[1][1] * -1 ], direction[0], direction[2] ];
        }
        this.rotate.str = this.rotate.str + str;
      } else if(e.key == 'ArrowUp' && this.view.x < 60) {
        this.view.x = this.view.x + 12;
      } else if(e.key == 'ArrowDown' && this.view.x > -61) {
        this.view.x = this.view.x - 12;
      } else if(e.key == 'ArrowLeft' && this.view.y > -11) {
        this.view.y = this.view.y - 12;
      } else if(e.key == 'ArrowRight' && this.view.y < 90) {
        this.view.y = this.view.y + 12;
      }
    },
    turnFace(face, type) {
      var newFace = JSON.parse(JSON.stringify(face));
      for(let i = 1; i < 3 && type; i++) {
        newFace[i][2] = face[0][i];
        newFace[2][2 - i] = face[i][2];
        newFace[2 - i][0] = face[2][2 - i];
        newFace[0][i] = face[2 - i][0];
      } for(let i = 1; i < 3 && !type; i++) {
        newFace[i][2] = face[2][2 - i];
        newFace[2][2 - i] = face[2 - i][0];
        newFace[2 - i][0] = face[0][i];
        newFace[0][i] = face[i][2];
      }
      return newFace;
    },
    turnCircle(list, type) {
      return [
        list[type ? 3 : 1],
        list[type ? 0 : 2],
        list[type ? 1 : 3],
        list[type ? 2 : 0]
      ]
    },
    turnLayer(face, type) {
      const cube = this.cube;
      var newCube = JSON.parse(JSON.stringify(cube));
      newCube[face] = this.turnFace(newCube[face], type);
      var list = [ [], [], [], [] ];
      switch(face) {
        case 0: 
          list = [ cube[5][2], cube[3][2], cube[4][2], cube[2][2] ];
          [ newCube[5][2], newCube[3][2], newCube[4][2], newCube[2][2] ] = this.turnCircle(list, type);
          break;
        case 1:
          list = [ cube[4][0], cube[3][0], cube[5][0], cube[2][0] ];
          [ newCube[4][0], newCube[3][0], newCube[5][0], newCube[2][0] ] = this.turnCircle(list, type);
          break;
        case 2:
          list = [ [ cube[1][0][0], cube[1][1][0], cube[1][2][0] ], [ cube[5][0][0], cube[5][1][0], cube[5][2][0] ], [ cube[0][0][0], cube[0][1][0], cube[0][2][0] ], [ cube[4][2][2], cube[4][1][2], cube[4][0][2] ] ];
          [ [ newCube[1][0][0], newCube[1][1][0], newCube[1][2][0] ], [ newCube[5][0][0], newCube[5][1][0], newCube[5][2][0] ], [ newCube[0][0][0], newCube[0][1][0], newCube[0][2][0] ], [ newCube[4][2][2], newCube[4][1][2], newCube[4][0][2] ] ] = this.turnCircle(list, type);
          break;
        case 3: 
          list = [ [ cube[1][2][2], cube[1][1][2], cube[1][0][2] ], [ cube[4][0][0], cube[4][1][0], cube[4][2][0] ], [ cube[0][2][2], cube[0][1][2], cube[0][0][2] ], [ cube[5][2][2], cube[5][1][2], cube[5][0][2] ] ];
          [ [ newCube[1][2][2], newCube[1][1][2], newCube[1][0][2] ], [ newCube[4][0][0], newCube[4][1][0], newCube[4][2][0] ], [ newCube[0][2][2], newCube[0][1][2], newCube[0][0][2] ], [ newCube[5][2][2], newCube[5][1][2], newCube[5][0][2] ] ] = this.turnCircle(list, type);
          break;
        case 4: 
          list = [ cube[0][2], [ cube[3][2][2], cube[3][1][2], cube[3][0][2] ], [ cube[1][0][2], cube[1][0][1], cube[1][0][0] ], [ cube[2][0][0], cube[2][1][0], cube[2][2][0] ] ];
          [ newCube[0][2], [ newCube[3][2][2], newCube[3][1][2], newCube[3][0][2] ], [ newCube[1][0][2], newCube[1][0][1], newCube[1][0][0] ], [ newCube[2][0][0], newCube[2][1][0], newCube[2][2][0] ] ] = this.turnCircle(list, type);
          break;
        case 5:
          list = [ cube[1][2], [ cube[3][0][0], cube[3][1][0], cube[3][2][0] ], [ cube[0][0][2], cube[0][0][1], cube[0][0][0] ], [ cube[2][2][2], cube[2][1][2], cube[2][0][2] ] ];
          [ newCube[1][2], [ newCube[3][0][0], newCube[3][1][0], newCube[3][2][0] ], [ newCube[0][0][2], newCube[0][0][1], newCube[0][0][0] ], [ newCube[2][2][2], newCube[2][1][2], newCube[2][0][2] ] ] = this.turnCircle(list, type);
      }
      this.cube = newCube;
      if(!face) {
        this.rotate.center += 180 * (type - 0.5);
      }
    },

    onChange() {
      this.hidden = !this.hidden;
    },
  },
}
</script>

<style>
.page{
  height: 96vh;
  position: relative;
}
.cube{
  margin: 30px auto;
  padding: 12px;
  width: 280px;
  border-radius: 12px;
  background-color: #25A3FF;
}
.row {
  width: 280px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.layer {
  width: 60px;
  height: 60px;
  margin: 5px;
  overflow: hidden;
}
.cube .line{
  width: 60px;
  height: 20px;
  display: flex;
}
.cube .item{
  width: 19px;
  height: 19px;
  border: 0.5px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 150ms;
  font-size: 0.6em;
}

.rubik_out{
  margin-left: calc(50% - 120px);
  margin-top: 100px;
  padding-bottom: 100px;
  transform-origin: 120px 120px -120px;
  transform-style: preserve-3d;
  transition: 300ms;
}
.rubik {
  position: relative;
  width: 240px;
  height: 240px;
  transform-origin: 120px 120px -120px;
  transform-style: preserve-3d;
  transition: 150ms;
}

.face {
  position: absolute;
  width: 240px;
  height: 240px;
  /* border-radius: 18px; */
  /* overflow: hidden; */
  background-color: #000;
  &.back{
    transform: translateZ(-240px) rotateY(180deg);
  }
  &.right{
    transform: rotateY(-270deg) translateX(50%) translateX(120px);
    transform-origin: top right;
  }
  &.left{
    transform: rotateY(270deg) translateX(-50%) translateX(-120px);
    transform-origin: center left;
  }
  &.top{
    transform: rotateX(90deg) translateY(-50%) translateY(-120px);
    transform-origin: top center;
  }
  &.bottom{
    transform: rotateX(-90deg) translateY(50%) translateY(120px);
    transform-origin: bottom center;
  }
}
.rubik .line{
  width: 240px;
  height: 80px;
  display: flex;
}
.rubik .item{
  margin: 0.5px;
  width: 79px;
  height: 79px;
  border-radius: 12px;
  /* border: 1px solid #00000040; */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 240ms;
  font-size: 0.6em;
  overflow: hidden;
  & img{
    width: 60px;
    height: 60px;
    margin: auto;
    transition: 150ms;
    transform: translateY(10px);
  }
}

.desc{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: max-content;
  padding: 36px 24px;
  border-radius: 18px 18px 0 0;
  background-color: #25A3FF;
  transition: 300ms;
  &.hidden{
    transform: translateY(80%);
  }
  & .icon{
    position: absolute;
    right: 0px;
    top: 0px;
    padding: 5px 10px;
    color: white;
    font-size: 24px;
  }
}
.desc .table{
  border: 2px solid #eeeeee;
  border-radius: 12px;
}
.desc .line {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  &:last-child{
    border-bottom: none;
  }
}
.desc .line .grid {
  padding: 8px 16px;
  font-size: 18px;
  width: 2em;
  text-align: center;
  border-right: 1px solid #eeeeee;
  color: #eeeeee;
  &.bold{
    font-weight: 600;
    color: white;
  }
  &:last-child{
    border-right: none;
  }
}
.icp{
  position: fixed;
  height: 4vh;
  background-color: black;
  padding-left: 18px;
  color: white;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}
</style>